import ContentsToReact from '@/components/ContentsToReact/ContentsToReact';
import PageHead from '@/components/PageHead/PageHead';
import { extractContents } from '@/helpers/extractContents';
import extractPageMetaFromRouteData from '@/helpers/extractPageMetaFromRouteData';
import useBodyClass from '@/hooks/useBodyClass/useBodyClass';
import { useInitialPageDataLayer } from '@/hooks/useInitialPageDataLayer/useInitialPageDataLayer';
import { PageModelBase } from '@/models/page';
import { CmsComponentsContext } from '@/page-templates/CmsComponentsContext';
import EasyGoPage from '@/third-party-templates/EnercityEasyGo/EnercityEasyGo';
import LegacyHeader from '@uikit/components/LegacyHeader/LegacyHeader.wrapper';
import PromoBanner from '@uikit/components/PromoBanner/PromoBanner';
import cmsComponents from './EasyGoProductPage.cmsComponents';

const EasyGoProductPage = (pageData: PageModelBase<{}>) => {
  const meta = extractPageMetaFromRouteData(pageData);

  const promoBanner =
    pageData.props.promoBannerVisible === 'promoBanner'
      ? pageData.props.promoBanner
      : undefined;

  const {
    extractedContents: [noticeBarArea, headerArea],
  } = extractContents(['notice-bar-area', 'header'], pageData.contents);

  const [header] = headerArea;

  useBodyClass('background-white');

  useInitialPageDataLayer();

  return (
    <CmsComponentsContext.Provider value={cmsComponents}>
      <PageHead {...meta} />
      {noticeBarArea && <ContentsToReact contents={noticeBarArea} />}
      <LegacyHeader {...header.props} isFullWidth />
      <EasyGoPage />
      {promoBanner && <PromoBanner banner={promoBanner} />}
    </CmsComponentsContext.Provider>
  );
};

export default EasyGoProductPage;
